import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { RequirementStatus } from "@wingspanhq/payments/dist/interfaces/requirement";
import { ISignedDocumentResponse } from "@wingspanhq/signed-documents/dist/lib/interfaces";
import { SignerRole } from "@wingspanhq/signed-documents/dist/lib/interfaces/signedDocumentTemplate";

export const selectorIsRequirementReadyToSignAsPayer = (
  requirement: IRequirementResponse,
  document?: ISignedDocumentResponse
) => {
  const requiresPayerSignature = document?.signatures?.find(
    signature => signature.signerRole === SignerRole.Payer
  );

  const isSignedByPayee = document?.events?.payeeSignedAt;

  return (
    requirement.dataSourceStatus !== RequirementStatus.Complete &&
    isSignedByPayee &&
    requiresPayerSignature
  );
};
